<template>
  <div class="view-container">
    <view-header>
      Users
      <template #items>
        <el-button icon="el-icon-plus" @click="onAdd"> Add </el-button>
      </template>
    </view-header>
    <el-table :data="items" style="width: 100%">
      <el-table-column prop="id" label="ID" width="80"> </el-table-column>
      <el-table-column prop="login" label="Login"> </el-table-column>
      <el-table-column prop="fullName" label="Full Name"> </el-table-column>
      <el-table-column prop="createdBy" label="Created By"> </el-table-column>
      <el-table-column prop="createdDate" label="Created Date">
        <template slot-scope="scope">
          <span v-bind:title="formatFull(scope.row.createdDate)">{{
            format(scope.row.createdDate)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="modifiedBy" label="Modified By"> </el-table-column>
      <el-table-column prop="modifiedDate" label="Modified Date">
        <template slot-scope="scope">
          <span v-bind:title="formatFull(scope.row.modifiedDate)">{{
            format(scope.row.modifiedDate)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Operations">
        <template slot-scope="scope">
          <el-button size="mini" @click="onEdit(scope.row.id)">Edit</el-button>
          <el-button size="mini" type="danger" @click="onDelete(scope.row.id)">
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :title="form.id ? 'Update user' : 'New user'"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="onDialogClose"
    >
      <el-form ref="form" :model="form" :rules="formRules" label-position="top">
        <el-form-item label="FullName" prop="fullName">
          <el-input v-model="form.fullName"></el-input>
        </el-form-item>
        <el-form-item label="Login" prop="login">
          <el-input v-model="form.login"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input v-model="form.password" show-password></el-input>
        </el-form-item>
        <el-form-item label="Re-password" prop="rePassword">
          <el-input v-model="form.rePassword" show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onDialogClose">Cancel</el-button>
        <el-button type="primary" @click="onSave">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ViewHeader from "@/components/ViewHeader";
import moment from "moment";
export default {
  name: "User",
  components: { ViewHeader },
  data() {
    const validateRePassword = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error("Two passwords don't match!"));
      } else {
        callback();
      }
    };
    return {
      items: [],
      form: {
        id: null,
        login: null,
        password: null,
        rePassword: null,
        fullName: null,
      },
      formRules: {
        login: [
          { required: true, message: "Please input Login", trigger: "blur" },
          {
            min: 4,
            max: 20,
            message: "Length should be 5 to 20",
            trigger: "blur",
          },
        ],
        fullName: [
          { required: true, message: "Please input FullName", trigger: "blur" },
        ],
        password: [
          { required: true, message: "Please input Password", trigger: "blur" },
          {
            min: 4,
            max: 20,
            message: "Length should be 5 to 20",
            trigger: "blur",
          },
        ],
        rePassword: [
          {
            required: true,
            message: "Please input Re-Password",
            trigger: "blur",
          },
          {
            validator: validateRePassword,
            trigger: "change",
          },
        ],
      },
      dialogVisible: false,
    };
  },
  methods: {
    reload() {
      const loader = this.$loading({
        lock: true,
      });
      this.$network
        .get("user")
        .then(({ data }) => {
          this.items = data;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Loading failed",
          });
        })
        .finally(() => {
          loader.close();
        });
    },
    onAdd() {
      this.dialogVisible = true;
    },
    onEdit(id) {
      const loader = this.$loading({
        lock: true,
      });
      this.$network
        .get(`user/${id}`)
        .then(({ data }) => {
          this.form.id = data.id;
          this.form.login = data.login;
          this.form.fullName = data.fullName;
          this.dialogVisible = true;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Loading failed",
          });
        })
        .finally(() => {
          loader.close();
        });
    },
    onSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = {
            login: this.form.login,
            password: this.form.password,
            fullName: this.form.fullName,
          };
          const loader = this.$loading({
            lock: true,
          });
          const request = this.form.id
            ? this.$network.put(`user/${this.form.id}`, data)
            : this.$network.post(`user`, data);
          request
            .then(() => {
              this.$message({
                type: "success",
                message: "Successfully saved!!!",
              });
              this.onDialogClose();
              this.reload();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Saving failed",
              });
            })
            .finally(() => {
              loader.close();
            });
        }
      });
    },
    onDelete(id) {
      this.$confirm(
        "This will permanently delete the item. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          const loader = this.$loading({
            lock: true,
          });
          this.$network
            .delete(`user/${id}`)
            .then(() => {
              this.$message({
                type: "success",
                message: "Delete completed",
              });
              this.reload();
            })
            .catch((e) => {
              this.$message({
                type: "info",
                message: "Deleting failed",
              });
              console.log(e.response);
            })
            .finally(() => {
              loader.close();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    onDialogClose() {
      this.form = {
        id: null,
        login: null,
        password: null,
        rePassword: null,
        fullName: null,
      };
      this.dialogVisible = false;
    },
    format(timestamp) {
      return moment(timestamp).fromNow();
    },
    formatFull(timestamp) {
      return moment(timestamp).format("HH:mm:ss DD.MM.yyyy");
    },
  },
  mounted() {
    this.reload();
  },
};
</script>

<style lang="scss" scoped></style>
